import React from "react";
import { InlineMath } from "react-katex";
import { makeClosedTask, normalizeMay2026Variant } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
import { getLinearGraphData, renderLinearGraphContext } from "./MaturaMay2026LinearGraphData";

export function generateTask(options = {}) {
  const variant = normalizeMay2026Variant(options);
  const line = getLinearGraphData(variant === "original");
  return makeClosedTask({
    type: "MaturaLinearCoefficientsGraphTruthClosedTask",
    taskNumber: "13.1",
    variant,
    tags: ["funkcja liniowa", "wykres"],
    data: {
      ...line,
      kind: "linearGraph",
      showInterceptPoints: false,
      context: renderLinearGraphContext(),
      graphBeforeInstruction: true,
      answerMode: "truth",
      statementTruth: [line.a > 0, line.b > 0],
      instruction: "Oceń prawdziwość poniższych stwierdzeń.",
      prompt: <div className="matura-truth-statement-list"><div className="matura-truth-statement"><span className="matura-truth-statement__number"><InlineMath math="1." /></span><span>Współczynnik kierunkowy <InlineMath math="a" /> jest dodatni.</span></div><div className="matura-truth-statement"><span className="matura-truth-statement__number"><InlineMath math="2." /></span><span>Wyraz wolny <InlineMath math="b" /> jest dodatni.</span></div></div>,
      explanationSteps: [
        {
          title: `Prosta jest ${line.a > 0 ? "rosnąca" : "malejąca"}, więc współczynnik kierunkowy ma znak ${line.a > 0 ? "dodatni" : "ujemny"}.`,
          latex: line.a > 0 ? "a>0" : "a<0",
        },
        {
          title: <>Prosta przecina oś <InlineMath math="Oy" /> {line.b > 0 ? "powyżej" : "poniżej"} osi <InlineMath math="Ox" />, więc wyraz wolny ma znak {line.b > 0 ? "dodatni" : "ujemny"}.</>,
          latex: line.b > 0 ? "b>0" : "b<0",
        },
      ],
    },
  });
}

export { checkClosedAnswer as checkAnswer, renderClosedAnswer as renderAnswer, renderClosedExplanation as renderExplanation, renderClosedInput as renderInput, renderClosedTask as renderTask, renderClosedUserAnswer as renderUserAnswer } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
